import React, { useMemo } from "react";
import { UserMinimalFragment } from '../../graphql/generated/definitions';

import { AvatarIcon } from "../icons";
import {
  AvatarGroup,
} from "../wombat-ui";
import { TailwindSize } from "../wombat-ui/components/Avatar/Avatar";
import { AvatarGroupProps } from "../wombat-ui/components/Avatar/AvatarGroup";

import {
  Box
} from "@chakra-ui/react"
import { useToggle } from 'react-use';

import UserListModal from "../users/UserListModal";

type UserAvatarGroupProps = {
  users: UserMinimalFragment[];
  max?: number;
  enableMenu?: boolean;
  size?: TailwindSize;
};

const UserAvatarGroup: React.FC<UserAvatarGroupProps> = ({ users, max, size, enableMenu = true }) => {
  const usersItems = useMemo(
    (): AvatarGroupProps["items"] =>
      users.map((user) => ({
        src: user?.avatar || undefined,
        name: user.name,
        alt: `${user.name} profile`,
        fallback: AvatarIcon,
        fallbackClassName: "w-full h-full text-dark-100"
      })),
    [users]
  );

  const [ isModalOpen, toggleModal ] = useToggle(false);

  return (
    <>
      <Box
        onClick={toggleModal}
        role="button"
      >
        <AvatarGroup
          items={usersItems}
          max={max}
          size={size}
        />
      </Box>
      <UserListModal
        users={users}
        isOpen={isModalOpen}
        onClose={toggleModal}
       />
    </>
  );
};

export default React.memo(UserAvatarGroup);
